export default __webpack_public_path__ + "static/about_mindset-d0c4960333626141e68cb1395c03e798.mp4";